<template>
  <component ref="form" :index="index" :formData="formData" :config="config" :readonly="readonly" :is="config.name" :mode="mode" v-model="_value" :prop-value="config.props" v-bind="config.props" @loadings="handleLoading"
  @refresh-data="handleRefreshData"/>
</template>
<script>

import components from '@/views/common/form/ComponentExport'

export default {
  name: "FormDesignRender",
  components: components,
  props:{
    mode:{
      type: String,
      default: 'DESIGN'
    },
    readonly:{
      type: Boolean,
      default: false
    },
    value: {
      default: undefined
    },
    config:{
      type: Object,
      default: ()=>{
        return {}
      }
    },
    index:{
      type: Number,
      default: 0
    },
    formData:{
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    handleLoading(e) {
      this.$emit("loadings", e);
      this.$forceUpdate()
    },
    validate(call){
      if (this.$refs.form.validate){
        this.$refs.form.validate(call)
      }else {
        call(true)
      }
    },
    handleRefreshData() {
      // 触发子组件的刷新方法
      if (this.$refs.form && this.$refs.form.refreshData) {
        this.$refs.form.refreshData();
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>
